"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUUID = exports.isApartmentsInfoErrors = exports.replaceSpaces = exports.valueOrDash = exports.formatToSnakeCase = void 0;
var lodash_1 = require("lodash");
var formatToSnakeCase = function (str) {
    str = lodash_1.trim(str.replace(new RegExp('province', 'ig'), ''));
    return str.split(' ').join('_');
};
exports.formatToSnakeCase = formatToSnakeCase;
var valueOrDash = function (str) {
    if (Array.isArray(str)) {
        if (!str.length) {
            return '-';
        }
        if (str.length === 1 || Math.min.apply(Math, str) == Math.max.apply(Math, str)) {
            return str[0];
        }
        return Math.min.apply(Math, str) + "-" + Math.max.apply(Math, str);
    }
    return str || '-';
};
exports.valueOrDash = valueOrDash;
var replaceSpaces = function (str) {
    if (!str) {
        return '';
    }
    return str.replace(/\s/g, '');
};
exports.replaceSpaces = replaceSpaces;
var isApartmentsInfoErrors = function (errors) {
    if (errors) {
        var keys = Object.keys(errors);
        var reg_1 = /^sections.apartment_info/;
        var apartmentInfoErrors_1 = [];
        keys.filter(function (item) {
            if (reg_1.test(item) && errors[item].length) {
                apartmentInfoErrors_1.push(item);
            }
        });
        return getErrorKeys(apartmentInfoErrors_1);
    }
};
exports.isApartmentsInfoErrors = isApartmentsInfoErrors;
var getErrorKeys = function (responseErrors) {
    var errorKeys = [];
    responseErrors.filter(function (item) {
        if (item.match(/\d/)) {
            errorKeys.push(item.match(/\d/)[0]);
        }
    });
    return Array.from(new Set(errorKeys));
};
var generateUUID = function () {
    //Timestamp
    var d = new Date().getTime();
    //Time in microseconds since page-load or 0 if unsupported
    var d2 = (typeof performance !== 'undefined' &&
        performance.now &&
        performance.now() * 1000) ||
        0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        //random number between 0 and 16
        var r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        }
        else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};
exports.generateUUID = generateUUID;
